import { COMING_SOON_LABEL } from '@agentic-ivy/shared-types';
import { cn } from '@/lib/utils';
import { useQualityTier } from '@/hooks/useQualityTier';
import { QUALITY_TIER_OPTIONS } from '@/types/models';

/** The quality tier every new video builds on, always in sight where the video is started. */
export function TierPicker({ className }: { className?: string }) {
  const [tier, setTier] = useQualityTier();
  return (
    <div
      role="radiogroup"
      aria-label="Quality tier"
      className={cn('inline-flex h-8 items-center rounded-full border border-black/10 dark:border-white/15 p-0.5', className)}
    >
      {QUALITY_TIER_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={tier === option.id}
          disabled={option.comingSoon}
          title={option.description}
          onClick={() => setTier(option.id)}
          className={cn(
            'h-full whitespace-nowrap rounded-full px-2.5 text-xs font-medium transition-colors duration-200',
            option.comingSoon
              ? 'cursor-not-allowed studio-text-secondary opacity-60'
              : tier === option.id
                ? 'bg-primary/10 dark:bg-primary/20 text-primary'
                : 'studio-text-secondary hover:bg-black/5 dark:hover:bg-white/10',
          )}
        >
          {option.label}
          {option.comingSoon && <span className="ml-1 text-[10px] font-normal">{COMING_SOON_LABEL}</span>}
        </button>
      ))}
    </div>
  );
}
